import { Element } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { PseudoClassSelector } from "./pseudo-class.js";
const { hasAttribute, hasInputType, hasName } = Element;
const { and, or } = Predicate;
/**
 * {@link https://drafts.csswg.org/selectors/#checked}
 */
export class Checked extends PseudoClassSelector {
    static of() {
        return new Checked();
    }
    constructor() {
        super("checked");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    /**
     * @privateRemarks
     * Checkedness and selectedness can change during the lifecycle of an element,
     * but we do not have access to that. We rely on the content attributes being
     * correctly set in the snapshot we test.
     */
    matches = or(and(hasInputType("checkbox", "radio"), hasAttribute("checked")), and(hasName("option"), hasAttribute("selected")));
    toJSON() {
        return super.toJSON();
    }
}
(function (Checked) {
    Checked.parse = PseudoClassSelector.parseNonFunctional("checked", Checked.of);
})(Checked || (Checked = {}));
//# sourceMappingURL=checked.js.map